import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { searchBarStyles } from './SearchBar.styles';

const SearchBar = ({
  value = '',
  onChange,
  placeholder = 'Ara...',
  fullWidth = false,
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      fullWidth={fullWidth}
      sx={searchBarStyles.searchField}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={searchBarStyles.searchIcon} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
